import {
  IonCol,
  IonContent,
  IonGrid,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
  IonText,
  IonToast,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

import { makeGETRequest } from "../../request/rawRequest";
import "./ForgotPassword.css";

interface Props {
  pathLogo: string;
}

const ForgotPassword: React.FC<Props> = ({ pathLogo }) => {
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [showToast, setShowToast] = useState<boolean>(false);

  const handleSubmit = () => {
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setError("Veuillez entrez un email valide");
      setShowToast(true);
      return;
    }
    makeGETRequest("/password?email=" + email)
      .then((response) => {
        if (response) {
          window.location.href = "/login";
        }
      })
      .catch((err) => {
        setError(err.response.data.error);
      });
    // Validation and password reset logic would go here

    // For now, let's assume that the password reset was successful
  };

  useEffect(() => {
    if (error.length > 0) setShowToast(true);
  }, [error]);

  return (
    <IonPage>
      {/* display error if had */}
      {showToast && (
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={error}
          position="top"
          color="danger"
          duration={2000}
        />
      )}

      <IonContent color="primary">
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonCol size-lg="3" size="6" size-sm="6">
                  <IonImg
                    style={{ marginTop: 50 }}
                    src={pathLogo}
                    alt="loginImage"
                    className="loginImg"
                  />

                  {/* <IonImg
                    src={pathLogo}
                    alt="loginImage"
                    className="loginImg"
                  /> */}
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <IonRow className="ion-justify-content-center">
                <IonCol size="12" size-sm="12" size-lg="10">
                  <IonRow className="ion-justify-content-center">
                    <IonText color="black" className="ion-text-center">
                      <h1>Mot de passe perdu</h1>
                      <h5>Veuillez entrer votre email</h5>
                    </IonText>
                  </IonRow>

                  <IonRow class="ion-justify-content-center">
                    <IonCol size="12" size-sm="12" size-lg="8">
                      <IonItem color="transparent">
                        <IonLabel color="black" position="floating">
                          Email
                        </IonLabel>
                        <IonInput
                          name="email"
                          type="email"
                          value={email}
                          onIonChange={(e) => setEmail(e.detail.value!)}
                          required
                        ></IonInput>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                </IonCol>
              </IonRow>

              <IonRow className="ion-justify-content-center">
                <IonCol size="12" size-sm="12" size-lg="10">
                  <IonRow className="ion-justify-content-center">
                    <IonText color="black" className="ion-text-center">
                      <h5>Pensez à regardez vos mails indésirables ou SPAMs</h5>
                    </IonText>
                  </IonRow>
                </IonCol>
              </IonRow>
              <IonRow
                className="ion-justify-content-center"
                style={{ paddingBottom: "30px", paddingTop: "30px" }}
              >
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <IonText
                      className="btn btn-shade"
                      onClick={() => handleSubmit()}
                    >
                      Envoyez l'email
                    </IonText>
                  </IonItem>
                </IonCol>
              </IonRow>

              <IonRow className="ion-justify-content-center">
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <IonText
                      className="btn btn-shade"
                      onClick={() => (window.location.href = "register")}
                    >
                      Pas encore de compte ?
                    </IonText>
                  </IonItem>
                </IonCol>
                <IonCol size="12" size-sm="12" size-lg="6">
                  <IonItem color="transparent">
                    <IonText
                      class="btn btn-login"
                      onClick={() => (window.location.href = "login")}
                    >
                      Se Connecter
                    </IonText>
                  </IonItem>
                </IonCol>
              </IonRow>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default ForgotPassword;
